var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.77,
    height: 19.13,
    viewBox: "0 0 19.77 19.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6965",
    "data-name": "Group 6965",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7411",
    "data-name": "Path 7411",
    d: "M575.236,27.55a7.483,7.483,0,1,0,7.483,7.483,7.483,7.483,0,0,0-7.483-7.483m0,12.459a4.976,4.976,0,1,1,4.976-4.976,4.976,4.976,0,0,1-4.976,4.976",
    transform: "translate(-565.35 -25.469)",
    fill: "#2e117f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7412",
    "data-name": "Path 7412",
    d: "M598.5,25.307h0a1.224,1.224,0,0,1-1.224-1.224v-5.13a1.224,1.224,0,0,1,2.448,0v5.13a1.224,1.224,0,0,1-1.224,1.224",
    transform: "translate(-588.617 -17.729)",
    fill: "#2e117f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7413",
    "data-name": "Path 7413",
    d: "M598.5,79.8h0a1.224,1.224,0,0,1-1.224-1.224v-5.13a1.224,1.224,0,0,1,2.448,0v5.13A1.224,1.224,0,0,1,598.5,79.8",
    transform: "translate(-588.617 -60.673)",
    fill: "#2e117f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7414",
    "data-name": "Path 7414",
    d: "M621.515,58.111h0a1.224,1.224,0,0,1-1.224,1.224h-5.13a1.224,1.224,0,0,1,0-2.448h5.13a1.224,1.224,0,0,1,1.224,1.224",
    transform: "translate(-601.745 -48.586)",
    fill: "#2e117f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7415",
    "data-name": "Path 7415",
    d: "M564,58.489h0a1.224,1.224,0,0,1-1.224,1.224h-5.13a1.224,1.224,0,1,1,0-2.448h5.13A1.224,1.224,0,0,1,564,58.489",
    transform: "translate(-556.422 -48.884)",
    fill: "#2e117f"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.fe225261b49da8a784300506adce8e62.svg";
export { ForwardRef as ReactComponent };